var _defs, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "icon-FullColour",
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.067,
    x2: 0.933,
    y1: 0.25,
    y2: 0.75,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dd342e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.056,
    stopColor: "#dc322d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.513,
    stopColor: "#d92729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d82327"
  })), /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#fff}\n        "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    cx: 38,
    cy: 38,
    r: 38,
    fill: "url(#linear-gradient)",
    "data-name": "Ellipse 1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(8.104 8.104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    d: "M116.8 86.9a29.894 29.894 0 0 0-29.887 29.583c0 .107-.009.206-.009.3A29.9 29.9 0 1 0 116.8 86.9zm0 5.979a23.863 23.863 0 0 1 17.992 8.181 16.366 16.366 0 0 0-18.036 6.4 16.365 16.365 0 0 0-17.911-6.436 23.861 23.861 0 0 1 17.955-8.145zm0 47.834A23.948 23.948 0 0 1 92.879 116.8c0-.627.036-1.253.081-1.862a10.5 10.5 0 0 1 20.829 1.871l-.815 8.933 3.786 2.694 3.777-2.694-.815-8.933a10.5 10.5 0 0 1 21 0 23.96 23.96 0 0 1-23.922 23.904z",
    className: "cls-2",
    "data-name": "Path 1",
    transform: "translate(-86.9 -86.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M515.67 360.1a5.667 5.667 0 0 0-5.67 5.67 5.67 5.67 0 1 0 11.34 0 5.661 5.661 0 0 0-5.67-5.67z",
    className: "cls-2",
    "data-name": "Path 2",
    transform: "translate(-472.481 -335.874)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M214.87 360.1a5.667 5.667 0 0 0-5.67 5.67 5.67 5.67 0 1 0 11.34 0 5.667 5.667 0 0 0-5.67-5.67z",
    className: "cls-2",
    "data-name": "Path 3",
    transform: "translate(-198.355 -335.874)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.342b9cd3cd80c2d6c5e6c0cf61f378ef.svg";
export { ForwardRef as ReactComponent };